import { render, staticRenderFns } from "./AssessmentOutro.vue?vue&type=template&id=2de21340&"
import script from "./AssessmentOutro.vue?vue&type=script&lang=js&"
export * from "./AssessmentOutro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports